import React from 'react';
import ImageWrapper from "../ImageWrapper/ImageWrapper";
import CTA from "../CTA/CTA";
var css = {
  "title": "oalp-12vp6",
  "subtitle": "oalp-2nfZX"
};
import TextWithIcon from "../TextWithIcon/TextWithIcon";
import FormatHtmlText from "../FormatHtmlText/FormatHtmlText";
import TitleComponent from "../Title/Title";
export var StaticItem = function StaticItem(_ref) {
  var image = _ref.image,
    title = _ref.title,
    subtitle = _ref.subtitle,
    cta = _ref.cta,
    widgetName = _ref.widgetName,
    track = _ref.track,
    locationId = _ref.locationId,
    ctaWrapperClassName = _ref.ctaWrapperClassName,
    ctaClassName = _ref.ctaClassName,
    formatTextWithIcon = _ref.formatTextWithIcon,
    formatHtmlText = _ref.formatHtmlText,
    metadata = _ref.metadata,
    handleOnClick = _ref.handleOnClick,
    dynamicParamsValues = _ref.dynamicParamsValues,
    handleIconClick = _ref.handleIconClick;
  return /*#__PURE__*/React.createElement(React.Fragment, null, image && (image.ctaAction ? /*#__PURE__*/React.createElement("a", {
    href: image.ctaAction
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    image: image
  })) : /*#__PURE__*/React.createElement(ImageWrapper, {
    image: image
  })), image && image.imageText && /*#__PURE__*/React.createElement("div", {
    style: image.imageText.style
  }, image.imageText.text), title && /*#__PURE__*/React.createElement(TitleComponent, {
    title: title,
    className: css.title
  }), formatHtmlText && /*#__PURE__*/React.createElement("div", {
    style: formatHtmlText.style
  }, /*#__PURE__*/React.createElement(FormatHtmlText, {
    formatHtmlText: formatHtmlText.statements,
    groupStyle: formatHtmlText.groupStyle
  })), subtitle && /*#__PURE__*/React.createElement("div", {
    className: css.subtitle,
    style: subtitle.style
  }, subtitle.text), formatTextWithIcon && formatTextWithIcon.textWithIcons && /*#__PURE__*/React.createElement(TextWithIcon, {
    textWithIcons: formatTextWithIcon.textWithIcons,
    style: formatTextWithIcon.style,
    title: formatTextWithIcon.title
  }), cta && cta.buttons && /*#__PURE__*/React.createElement("div", {
    className: ctaWrapperClassName,
    style: cta.style
  }, cta.buttons.map(function (button, idx) {
    return /*#__PURE__*/React.createElement(CTA, {
      key: "widget_".concat(widgetName, "_cta_").concat(idx),
      button: button,
      widgetKey: widgetName,
      track: track,
      locationId: locationId,
      metadata: metadata,
      "data-aut-id": "".concat(widgetName, "_cta"),
      customClass: ctaClassName,
      handleOnClick: handleOnClick,
      dynamicParamsValues: dynamicParamsValues,
      handleIconClick: handleIconClick
    });
  })));
};
export default StaticItem;